import {
  checkForNeutralComments,
  getParentComments,
  getUnresolvedComments,
} from 'utils/comments';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { ProjectState } from 'redux/reducers/project';
import { useMemo } from 'react';

export const useAnyUnresolvedComments = (): boolean => {
  const { project, reviewComments } = useSelector<RootState, ProjectState>(
    (state: RootState) => state.project
  );

  const parentComments = useMemo(
    () => getParentComments(reviewComments),
    [reviewComments]
  );

  if (parentComments.length === 0) {
    return false;
  }

  return getUnresolvedComments(reviewComments, project.status);
};

export const useAnyNeutralComments = (): boolean => {
  const { project, reviewComments } = useSelector<RootState, ProjectState>(
    (state: RootState) => state.project
  );

  if (project.status !== 'review') {
    return false;
  }

  const parentComments = useMemo(
    () => getParentComments(reviewComments),
    [reviewComments]
  );

  if (parentComments.length === 0) {
    return false;
  }

  return checkForNeutralComments(reviewComments);
};
